import { render, staticRenderFns } from "./LicensesDialogSelector.vue?vue&type=template&id=671b4c78"
import script from "./LicensesDialogSelector.vue?vue&type=script&lang=js"
export * from "./LicensesDialogSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports